// Safe storage helper to handle SecurityError exceptions in iframe contexts
export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch (e) {
      console.warn('Failed to access localStorage:', e)
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value)
    } catch (e) {
      console.warn('Failed to set localStorage item:', e)
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      console.warn('Failed to remove localStorage item:', e)
    }
  },
  clear(): void {
    try {
      localStorage.clear()
    } catch (e) {
      console.warn('Failed to clear localStorage:', e)
    }
  },
  key(index: number): string | null {
    try {
      return localStorage.key(index)
    } catch (e) {
      console.warn('Failed to get localStorage key:', e)
      return null
    }
  },
  get length(): number {
    try {
      return localStorage.length
    } catch (e) {
      console.warn('Failed to get localStorage length:', e)
      return 0
    }
  },
}

export const safeSessionStorage = {
  getItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key)
    } catch (e) {
      console.warn('Failed to access sessionStorage:', e)
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value)
    } catch (e) {
      console.warn('Failed to set sessionStorage item:', e)
    }
  },
  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key)
    } catch (e) {
      console.warn('Failed to remove sessionStorage item:', e)
    }
  },
  clear(): void {
    try {
      sessionStorage.clear()
    } catch (e) {
      console.warn('Failed to clear sessionStorage:', e)
    }
  },
  key(index: number): string | null {
    try {
      return sessionStorage.key(index)
    } catch (e) {
      console.warn('Failed to get sessionStorage key:', e)
      return null
    }
  },
  get length(): number {
    try {
      return sessionStorage.length
    } catch (e) {
      console.warn('Failed to get sessionStorage length:', e)
      return 0
    }
  },
}

// Import the comprehensive ResizeObserver error handler
export { createSafeResizeObserver } from './ResizeObserverErrorHandler'
